import * as Validator from "validatorjs";

/**
 * Custom rule to validate that an array has a minimum number of items.
 *
 * @param {string | any[]} value
 * @param {number} min
 * @returns {boolean}
 */
Validator.register(
  "array_min",
  (value: any[], min: number, attribute): boolean => value.length >= min,
  "The :attribute field does not have enough items.",
);

export default Validator;
